/**
 * Local Control Room: frontend runs without a login gate.
 * Backend is not changed. API calls may still 401; pages still render.
 */
export const SKIP_AUTH =
  import.meta.env.VITE_SKIP_AUTH !== '0' && import.meta.env.VITE_SKIP_AUTH !== 'false';

export const LOCAL_OPERATOR = {
  id: 'local-operator',
  username: 'local-operator',
  email: 'operator@local',
  role: 'admin' as const,
  permissions: [
    'view_dashboard',
    'view_charts',
    'view_knowledge_graph',
    'view_performance',
    'view_learning',
    'apply_corrections',
    'manage_alerts',
    'manage_users',
    'manage_services',
    'view_logs',
    'view_metrics',
    'execute_trades',
    'manage_config',
  ],
  createdAt: 0,
  lastLogin: Date.now(),
};

export const LOCAL_ACCESS_TOKEN = 'local-dev-bypass';
